import { RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/publications",
        name: "publications",
        component: () => import("@/modules/Publications/pages/PublicationList.vue"),
        meta: {
            requiresAuth: true,
            breadcrumb: "menu.publications",
            title: "publications.title_management",
        },
    },
    {
        path: "/publications/create",
        name: "publications-create",
        component: () => import("@/modules/Publications/pages/PublicationForm.vue"),
        meta: {
            requiresAuth: true,
            breadcrumb: "publications.create",
            title: "publications.create",
        },
    },
    {
        path: "/publications/:id",
        name: "publications-view",
        component: () => import("@/modules/Publications/pages/PublicationForm.vue"),
        meta: {
            requiresAuth: true,
            breadcrumb: "publications.view",
            title: "publications.view",
        },
    },
];

export default routes;
